import { useState, useCallback, useRef } from 'react';
import { WebPayService } from '../services/webpay';
import { PaymentRequest, PaymentResponse, WebPayHookOptions } from '../types';

export const useWebPay = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const webPayServiceRef = useRef(new WebPayService());

  const initiatePayment = useCallback(async (
    paymentRequest: PaymentRequest,
    options?: WebPayHookOptions
  ) => {
    setIsLoading(true);
    setError(null);

    try {

      const paymentData: PaymentRequest = {
        ...paymentRequest,
        onComplete: (response: PaymentResponse) => {
          console.log('Payment response:', response);
          setIsLoading(false);

          if (response.resp === '00' || response.resp === 'Approved') {
            options?.onSuccess?.(response);
          } else if (response.resp === 'Z6') {
            options?.onCancel?.();
          } else {
            options?.onError?.(response);
          }
        }
      };

      console.log('Starting payment with data:', paymentData);
      await webPayServiceRef.current.initiatePayment(paymentData);
      
    } catch (err) {
      console.error('Payment error:', err);
      setIsLoading(false);
      const errorMessage = err instanceof Error ? err.message : 'Payment initialization failed';
      setError(errorMessage);
      options?.onError?.({
        resp: 'ERROR',
        desc: errorMessage,
        txnref: paymentRequest.txn_ref,
        payRef: '',
        retRef: '',
        amount: paymentRequest.amount,
        apprAmt: 0
      });
    }
  }, []);

  return {
    initiatePayment,
    isLoading,
    error,
    clearError: () => setError(null)
  };
};